<script setup lang="ts">
import { type CheckboxProps, useCheckbox } from "@formwerk/core";

const props = defineProps<CheckboxProps<string>>();
const { labelProps, inputProps, errorMessage, errorMessageProps, isTouched } = useCheckbox(props);
</script>

<template>
  <div>
    <label v-bind="labelProps">
      <input v-bind="inputProps">
      {{ label }}
      <UiFieldRequired v-if="required" />
    </label>
    <div v-if="isTouched && errorMessage" v-bind="errorMessageProps" class="text-sm text-danger">
      {{ errorMessage }}
    </div>
  </div>
</template>
